import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  cmaId: string;
  priceMin?: number | null;
  priceMax?: number | null;
};

export const useUpdateEstimationPrice = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getCMAApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, priceMin, priceMax } = params;
      const response = await api.cMAControllerSetEstimatedPrice({
        id: cmaId,
        setEstimatedPriceRequestDto: { min: priceMin, max: priceMax },
      });

      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
        });
      }, 2000);
      onSuccess?.();
      return response;
    },
    onError: async (error, { cmaId }) => {
      console.error(`Failed to update CMA with id ${cmaId}`, error);
    },
    mutationKey: [CMA_SCOPE_KEY, "update-estimation-price"],
  });

  return mutation;
};
